import { apiService } from '../../../../'
import {
  BankAccountResponse,
  BankAccountEligibleResponse,
  BankAccountCreateLinkTokenResponse,
  BankAccountCreateLinkTokenRequest,
  BankAccountAddPublicTokenResponse,
  BankAccountLinkResponse,
  BankAccountLinkRequest,
  BankAccountAddPublicTokenRequest,
  UpdatePreferredBankAccountRequest,
  BankAccountUpdateLinkTokenResponse,
  BankAccountUpdateLinkTokenRequest,
  BankAccountValidateRequest,
  BankAccountValidateResponse,
} from '../types'

const baseURL = 'portal/consumers/account/bank-accounts'

export const bankAccountsService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getBankAccounts: build.query<BankAccountResponse, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'get',
        }
      },
      providesTags: ['BankAccounts'],
    }),
    deleteBank: build.mutation<void, string>({
      query: (id) => ({
        url: `${baseURL}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['BankAccounts'],
    }),
    updatePreferredBank: build.mutation<void, UpdatePreferredBankAccountRequest>({
      query: (req) => ({
        url: `${baseURL}/${req.params.id}/preferred`,
        method: 'put',
      }),
      invalidatesTags: (_res, _err, req) => ['BankAccounts', ...req.cache.invalidatesTags],
    }),
    checkAchEligible: build.query<BankAccountEligibleResponse, void>({
      query: () => {
        return {
          url: `${baseURL}/eligible`,
          method: 'get',
        }
      },
      providesTags: ['BankAccounts'],
    }),
    createLinkToken: build.mutation<BankAccountCreateLinkTokenResponse, BankAccountCreateLinkTokenRequest>({
      query: (data) => {
        return {
          url: `${baseURL}/create-link-token`,
          method: 'POST',
          data,
        }
      },
    }),
    createRelinkToken: build.mutation<BankAccountUpdateLinkTokenResponse, BankAccountUpdateLinkTokenRequest>({
      query: (data) => {
        return {
          url: `${baseURL}/create-update-token`,
          method: 'POST',
          data,
        }
      },
    }),
    getPlaidBankAccounts: build.mutation<BankAccountAddPublicTokenResponse, BankAccountAddPublicTokenRequest>({
      query: (data) => {
        return {
          url: `${baseURL}/add-public-token`,
          method: 'POST',
          data,
        }
      },
    }),
    linkBankAccount: build.mutation<BankAccountLinkResponse, BankAccountLinkRequest>({
      query: (data) => {
        return {
          url: `${baseURL}/link-account`,
          method: 'POST',
          data,
        }
      },
      invalidatesTags: ['BankAccounts'],
    }),
    validateBankAccount: build.mutation<BankAccountValidateResponse, BankAccountValidateRequest>({
      query: (data) => {
        return {
          url: `${baseURL}/validate`,
          method: 'POST',
          data,
        }
      },
    }),
  }),
})
